export const GET_OPERATION = 'GET_OPERATION_TRIM';
export const GET_OPERATION_SUCCESS = 'GET_OPERATION_SUCCESS';
export const GET_OPERATION_FAIL = 'GET_OPERATION_TRIM_FAIL';
export const SAVE_OPERATION = 'SAVE_OPERATION_TRIM';
export const SAVE_OPERATION_SUCCESS = 'SAVE_OPERATION_TRIM_SUCCESS';
export const SAVE_OPERATION_FAIL = 'SAVE_OPERATION_TRIM_FAIL';
